export { default as Address } from './address';
export { default as Truck } from './truck';
export { default as Heart } from './heart';
export { default as Settings } from './settings';
export { default as Mark } from './mark';
export { default as EditReceipt } from './edit-receipt';
export { default as Trash } from './trash';
export { default as FavHeart } from './fav-heart';
export { default as Right } from './right';
export { default as Back } from './back';
export { default as Filter } from './filter';
export { default as Sort } from './sort';
export { default as PosCard } from './pos-card';
export { default as TruckFast } from './truck-fast';
export { default as BoxTick } from './box-tick';
export { default as Discount } from './discount';
export { default as HeartPlus } from './heart-plus';
export { default as ExternalLink } from './external-link';
export { default as Clock } from './clock';
export { default as MapPinIcon } from './map-pin-icon';
export { default as TrashCartPopUpIcon } from './trash-cart-popup-icon';
